import { CLEAR_INLINE_ERRORS, HIDE_LOADER, SET_INLINE_ERROR, SET_PAGE_ERROR, SHOW_LOADER, SHOW_SUPPORT_MODAL, SET_FORM_IS_SUBMITTING, SET_AUTO_REG_MODE, SET_GLOBAL_LOADERS, } from "./types";
var initialState = {
    isLoading: false,
    loadingText: undefined,
    showSupportModal: false,
    pageError: undefined,
    inlineErrors: undefined,
    formIsSubmitting: false,
    isAutoRegMode: false,
    globalLoaders: {},
};
export var appStateReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case SHOW_LOADER:
            return Object.assign({}, state, { isLoading: true, loadingText: action.payload });
        case HIDE_LOADER:
            return Object.assign({}, state, { isLoading: false, loadingText: undefined });
        case SHOW_SUPPORT_MODAL:
            return Object.assign({}, state, { showSupportModal: action.payload });
        case SET_PAGE_ERROR:
            return Object.assign({}, state, { pageError: action.payload });
        case SET_INLINE_ERROR:
            return Object.assign({}, state, { inlineErrors: Object.assign({}, state.inlineErrors, action.payload) });
        case CLEAR_INLINE_ERRORS:
            if (action.payload) {
                var newPayload_1 = state.inlineErrors;
                if (newPayload_1) {
                    action.payload.forEach(function (key) {
                        delete newPayload_1[key];
                    });
                }
                return Object.assign({}, state, { inlineErrors: newPayload_1 });
            }
            else {
                return Object.assign({}, state, {
                    inlineErrors: undefined,
                });
            }
        case SET_FORM_IS_SUBMITTING:
            return Object.assign({}, state, { formIsSubmitting: action.payload });
        case SET_AUTO_REG_MODE:
            return Object.assign({}, state, { isAutoRegMode: action.payload });
        case SET_GLOBAL_LOADERS:
            return Object.assign({}, state, { globalLoaders: Object.assign({}, state.globalLoaders, action.payload) });
        default:
            return state;
    }
};
